import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-job-match-actions-modal',
  templateUrl: './job-match-actions-modal.component.html'
})
export class JobMatchActionsModalComponent implements OnInit {

  modalData: any;
  public onClose: Subject<any>;
  private isRefreshDone = false;
  resendReason: string;
  otherReasonNotes: string;

  constructor(
    private bsModalRef: BsModalRef,
    public bsModalService: BsModalService
  ) {
    this.onClose = new Subject();
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit() {
  }

  get jobMatchIdArrayJson(): string {
    return JSON.stringify([].concat(this.modalData.jobMatchId));
  }

  closeModal() {
    if (this.modalData.type === 'jobMatchAction' && this.modalData.modalType === 'UPLOAD_RESUME' && !this.isRefreshDone) {
      this.closeModalAndRefresh();
      return;
    }
    this.onClose.next(null);
    this.bsModalRef.hide();
  }

  closeModalAndRefresh() {
    this.onClose.next(null);
    this.bsModalRef.hide();
    this.runRefreshCallback();
  }

  saveCallback() {
    if (this.modalData.type === 'jobMatchAction') {
      if (this.modalData.modalType !== 'UPDATE_CONTACT') {
        this.onClose.next(true);
        this.bsModalRef.hide();
      }
      this.runRefreshCallback();
      return;
    }
    this.onClose.next(true);
    this.bsModalRef.hide();
  }

  refreshCallback() {
    this.runRefreshCallback();
  }

  resendAction(resendFlag: boolean) {
    this.onClose.next(null);
    this.bsModalRef.hide();
    if (resendFlag) {
      this.modalData.resendCallback(this.resendReason, this.otherReasonNotes);
    }
  }

  onVoiceTranscript(transcript: string) {
    if (this.otherReasonNotes) {
      this.otherReasonNotes += ' ' + transcript;
    } else {
      this.otherReasonNotes = transcript;
    }
  }

  receiveFormalizedComment(event: string) {
    this.otherReasonNotes = event;
  }

  private runRefreshCallback() {
    this.isRefreshDone = true;
    const d = this.modalData;
    if (d.context === 'candidateJobMatchCard') {
      if (d.callbackType === 'refreshJobMatch') {
        d.removeOrRefreshCardCallback();
      } else if (d.callbackType === 'refreshWorkflow') {
        d.refreshCallback();
      }
    } else if (d.context === 'candidateJobMatches') {
      d.refreshCallback();
    }
  }

}
